import * as React from 'react';
import { FormGroup, Label } from './styles/common';

export function FormInputPrice({
  label, onChange, name, error, valid, type = 'text', placeholder, value, suffix = '€', allowDecimals = false,
  hint,
}) {
  const inputRef = React.useRef(null);

  if (value == null) {
    value = '';
  } else if (typeof value === 'number') {
    value = String(value);
  }

  let formattedValue;
  if (allowDecimals) {
    formattedValue = value ? `${value} ${suffix}` : '';
  } else {
    const numericValue = value.replace(/[^\d,]/g, '');
    formattedValue = numericValue
      ? `${Number(numericValue.replace(/,/g, '')).toLocaleString()} ${suffix}`
      : '';
  }

  const handleInputChange = (e) => {
    let rawValue;
    if (allowDecimals) {
      const cleaned = e.target.value.replace(/[^\d,]/g, '');
      const firstComma = cleaned.indexOf(',');
      rawValue = firstComma === -1
        ? cleaned
        : cleaned.slice(0, firstComma + 1) + cleaned.slice(firstComma + 1).replace(/,/g, '');
    } else {
      rawValue = e.target.value.replace(/[^\d]/g, '');
    }
    onChange(rawValue);
  };

  const handleKeyUp = (e) => {
    const { selectionStart } = e.target;

    if (inputRef.current) {
      const newCursorPos = Math.min(selectionStart, inputRef.current.value.length - 2);
      setTimeout(() => {
        inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    }
  };

  return (
    <FormGroup>
      {label !== undefined && (
        <Label>
          {label}
          {' '}
          (
          {suffix}
          )
        </Label>
      )}
      <input
        ref={inputRef}
        placeholder={placeholder}
        className={`form-control ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`}
        type={type}
        value={formattedValue}
        name={name}
        onChange={handleInputChange}
        onKeyUp={handleKeyUp}
        aria-invalid={error ? 'true' : undefined}
      />
      <div className="invalid-feedback">{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
